define('home/views/common/BaseSettingsView',[
    'underscore',
    'backbone-marionette',

    'core/utils/html/nodeTypes',

    'home/mixins/withFetchingView',
    'home/models/Session',
], function (
    _,
    Marionette,

    nodeTypes,

    withFetchingView,
    Session
) {
    'use strict';

    var BaseSettingsView = Marionette.ItemView.extend({
        events: {
            'submit form': 'submitHandler',
            'change input[type=checkbox], input[type=radio], select': 'changeHandler',
            'keyup input[type=text], input[type=password]': 'changeHandler',
        },

        initialize: function () {
            this.model.ensureFetched();
            this.session = Session.get();
            this.listenTo(this.model, 'invalid sync', this.render);
            this.listenTo(this.model, 'error', this.handleValidationError);
        },

        onRender: function () {
            this.$form = this.$('form');
            this.$saveStatus = this.$('[data-role=save-status]');
            this.saveBtn = this.$('[data-role=save-btn]')[0];

            // get form data and set it on the model on render so
            // we can detect changes when a user is updating the form.
            this.model.set(this.getFormData());
        },

        handleValidationError: function (model, response) {
            model.validationError = response.responseJSON;
            this.render();
        },

        isDoneFetching: function () {
            return this.model.fetched;
        },

        serializeData: function () {
            var data = Marionette.ItemView.prototype.serializeData.call(this, arguments);
            data.errors = this.model.validationError || {};
            return data;
        },

        changeHandler: _.debounce(function () {
            this.updateButtonState(this.model.changedAttributes(this.getFormData()));
        }, 100),

        updateButtonState: function (isEnabled) {
            this.saveBtn.disabled = !isEnabled;
        },

        saveFormData: function () {
            // also used in dismiss handler in withEmailConfirmedModal
            var formData = this.getFormData();
            this.model.set(formData);
        },

        submitHandler: function (evt) {
            evt.preventDefault();

            this.$saveStatus.addClass('is-saving');
            this.clearErrors();
            this.updateStatus('is-saving');

            this.saveFormData(evt);

            if (evt.currentTarget && evt.currentTarget[0] && nodeTypes.isButton(evt.currentTarget[0]) && evt.currentTarget[0].getAttribute('data-tag') === 'dismiss')
                return this.updateStatus('is-saved');

            var options = {};
            options.success = _.bind(function () {
                this.session.user.set('username', this.model.get('username'));
            }, this);

            this.model.save(null, options)
                      .done(_.bind(this.updateStatus, this, 'is-saved'));
        },

        updateStatus: function (status) {
            this.$saveStatus.removeClass('is-saving is-saved')
                            .addClass(status);
        },

        getFormData: function () {
            return _.reduce(this.$form.serializeArray(), function (data, elem) {
                data[elem.name] = elem.value;
                return data;
            }, {});
        },

        clearErrors: function () {
            this.$el.find('.is-error').removeClass('is-error');
            this.$el.find('.fieldset__description--error').hide();
            this.model.validationError = null;
        },
    });

    withFetchingView.call(BaseSettingsView.prototype);

    return BaseSettingsView;
});

